import styled, { css } from 'styled-components';
import { Slider, SliderPrevious, SliderNext } from 'components/Slider/index';
import CardService from 'components/CardService';

import { colors } from '../../styles/stylesheets';

export const CardServiceCustom = styled(CardService)`
  margin: 0 24px 24px 0;
`;

const ButtonDefault = css`
  width: 40px;
  height: 40px;
  top: calc(50% - 20px - 20px);
  border-radius: 40px;
  background-color: ${colors.greyLighter2};
  color: ${colors.greyDark};
  opacity: 0.9;
  &.disabled{
    display: block;
    opacity: 0.2;
    :hover{
      opacity: 0.2;
    }
  }
`;
export const SliderPreviousCustom = styled(SliderPrevious)`
  ${ButtonDefault}
  left: 0;
`;
export const SliderNextCustom = styled(SliderNext)`
  ${ButtonDefault}
  right: 0;
`;

export const SliderCustom = styled(Slider)`
  ove
`;
